<template>
  <v-container fluid>
    <v-row
      class="rounded elevation-3 white pa-4">
      <v-col
        cols="12"
        class="d-flex flex-row justify-space-between align-center">
        <h2>
          สร้าง Location (WMS Location)
        </h2>
      </v-col>
      <v-col
        :cols="results.length ? '6' : '12'"
        class="pa-6">
        <validation-observer
          ref="createLocationForm"
          tag="form"
          @submit.prevent="submitForm()">
          <h3 class="mb-1">
            Form Create
          </h3>
          <p class="text-caption grey--text mb-4">
            Location เป็นรายการกลาง ใช้ร่วมกันทุก store — ชื่อที่ซ้ำกับของเดิม (ไม่สนตัวพิมพ์เล็กใหญ่) จะถูกข้าม
          </p>
          <text-area-form
            v-model="locationText"
            :disabled="loadingCreate"
            out-field-label="Locations (บรรทัดละ 1 location)"
            outlined
            :rules="locationRules"
            placeholder="Locations"
            name="Locations" />
          <v-btn
            :loading="loadingCreate"
            color="secondary"
            type="submit">
            CREATE
          </v-btn>
        </validation-observer>
      </v-col>
      <v-divider
        v-if="results.length"
        vertical></v-divider>
      <v-col
        v-if="results.length"
        cols="6"
        class="pa-6">
        <div class="d-flex justify-space-between">
          <h3 class="mb-4">
            Create Results
          </h3>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            color="green"
            @click="downloadCsv(results)">
            EXPORT
            <v-icon class="ml-1">
              mdi-file
            </v-icon>
          </v-btn>
          <v-btn
            color="secondary"
            @click="printLabel(results)">
            PRINT
            <v-icon class="ml-1">
              mdi-printer
            </v-icon>
          </v-btn>
        </div>
        <v-simple-table>
          <thead>
            <tr>
              <th>Location</th>
              <th>Status</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(result, index) in results"
              :key="`result-${index}`"
              :class="getResultClass(result.status)">
              <td>{{ result.name }}</td>
              <td>{{ result.status }}</td>
              <td>{{ result.message }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StockMappingProvider from '@/resources/StockMappingProvider'
import { extend } from 'vee-validate'
import { mapActions } from 'vuex'
import { ExportToCsv } from 'export-to-csv'

extend('no_colon', {
  validate: (value) => !value.includes(':'),
  message: "Cannot contain ':'"
})

const stockMappingService = new StockMappingProvider()

export default {
  data () {
    return {
      results: [],
      locationText: '',
      locationRules: {
        required: true,
        no_colon: true
      },
      loadingCreate: false
    }
  },
  methods: {
    ...mapActions({
      setPrintLocations: 'StockMapping/setPrintLocations'
    }),
    async createLocations () {
      try {
        this.loadingCreate = true
        const names = this.locationText.split('\n').map((loText) => loText.trim()).filter((loText) => loText)
        const { data } = await stockMappingService.createLocations({ names })
        this.results = data
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      } finally {
        this.loadingCreate = false
      }
    },
    async submitForm () {
      const valid = await this.$refs.createLocationForm.validate()
      if (valid) {
        this.createLocations()
      }
    },
    getResultClass (status) {
      // skipped = มี location ชื่อนี้อยู่แล้ว (ยังได้ id กลับมา พิมพ์ต่อได้)
      if (status === 'created') return 'green--text'
      if (status === 'skipped') return 'orange--text'
      return 'red--text'
    },
    printLabel (results) {
      this.setPrintLocations(results)
      this.$router.push({ name: 'StockMappingPrintLocation' })
    },
    async downloadCsv (results) {
      const payload = results.map((re) => ({ name: re.name, qrcode: re.name }))
      const options = {
        filename: 'locations_qrcode',
        showLabels: true,
        useKeysAsHeaders: true
      }
      const csvExporter = new ExportToCsv(options)
      csvExporter.generateCsv(payload)
    }
  }
}
</script>
